import { render, staticRenderFns } from "./NotesCreate.vue?vue&type=template&id=016c52f4"
import script from "./NotesCreate.vue?vue&type=script&lang=js"
export * from "./NotesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports